import React, { useEffect, useState } from 'react';

/**
 * ClubSporiumTeklif: satış toplantısı için dijital pazarlama teklif sunumu.
 * Route: /r/clubsporium-teklif (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 16 slayt, 16:9. Tasarım dili Gürgençler lansman fikirleri sunumundan geliyor,
 * CSS'i onunla ortak; o sunum canlıda duruyor ve bozulmamalı.
 * Yeniden üretmek için: node src/pages/clubsporium-teklif/build.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~77KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function ClubSporiumTeklif() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./clubsporiumTeklifHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Club Sporium · Dijital Pazarlama Teklifi"
      srcDoc={html}
      style={fill}
    />
  );
}
